export default __webpack_public_path__ + "static/media/jumpingGame.a87af0aa.png";